import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/store';
import { updatePolicy } from '../../../../../services/CaseManagementService/policySlice';

const PolicyNameEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const policy = useAppSelector((state) => state.policy.currentPolicy);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updatePolicy({ policyName: event.target.value }));
  };

  return (
    <TextField
      label="Policy Name"
      value={policy?.policyName || ''}
      onChange={handleChange}
      size="small"
      required
      placeholder="Enter policy name"
      sx={{ 
        '& .MuiOutlinedInput-root': {
          backgroundColor: '#ffffff',
        }
      }}
    />
  );
};

export default PolicyNameEditor;
